import React from "react";

const webProjects = [
  {
    image: "/portfolio/swiss-foundation.png",
    alt: "MedicalNet Switzerland website concept",
    badge: "Web Project / Switzerland",
    title: "MedicalNet Switzerland",
    description: "Institutional web concept for a healthcare foundation and medical network in Switzerland.",
  },
  {
    image: "/portfolio/gundega-zurich.png",
    alt: "Website concept for aesthetic clinics and med spas",
    badge: "Web / Aesthetic Clinics",
    title: "Web for Aesthetic Clinics",
    description: "Minimal luxury website concept for aesthetic clinics, med spas, beauty studios and premium wellness brands.",
  },
  {
    image: "/portfolio/oxibar-mexico.png",
    alt: "OXIBAR México landing page with AI assistant",
    badge: "Concept / Mexico",
    title: "OXIBAR México",
    description: "Medical equipment rental landing page concept with AI assistant for lead capture and rental requests.",
  },
  {
    image: "/portfolio/grit-skin-men-skincare.png",
    alt: "Grit Skin men's skincare landing page",
    badge: "Own Brand Concept",
    title: "Grit Skin",
    description: "Men’s skincare concept focused on clean, practical and masculine personal care.",
  },
];

const products = [
  {
    image: "/portfolio/koda.png",
    alt: "Koda AI-assisted child therapy product",
    badge: "SaaS Product",
    title: "Koda",
    domain: "osokoda.com",
    description: "Bilingual AI-assisted tool designed to support child therapists, psychologists and psychiatrists through guided interaction.",
    link: "https://osokoda.com",
  },
  {
    image: "/portfolio/medicbro.png",
    alt: "MedicBro AI medical documentation product",
    badge: "SaaS Product",
    title: "MedicBro",
    domain: "medicbro.app",
    description: "AI medical assistant for consultation summaries, prescriptions and clinical workflow support.",
    link: "https://medicbro.app",
  },
  {
    image: "/portfolio/medicbro-clinic.png",
    alt: "MedicBro Clinic AI healthcare platform",
    badge: "SaaS Product",
    title: "MedicBro Clinic",
    domain: "MedicBro ecosystem",
    description: "Clinical platform concept focused on digital healthcare workflows, patient management and AI-assisted support.",
    link: "#",
  },
  {
    image: "/portfolio/travik-app.png",
    alt: "Travik travel app",
    badge: "SaaS Product",
    title: "Travik App",
    domain: "travik.app",
    description: "Travel app designed to organize trips, documents, itineraries and smart travel tools in one place.",
    link: "https://travik.app",
  },
  {
    image: "/portfolio/travik-translator-production.png",
    alt: "Travik Translator production work",
    badge: "AI Product",
    title: "Travik Translator Production",
    domain: "In production",
    description: "AI-powered travel translation product currently in production for real-world multilingual travel support.",
    link: "https://travik.app",
  },
  {
    image: "/portfolio/business-dashboards.png",
    alt: "Custom business dashboards by FIKAMI",
    badge: "Dashboard Solutions",
    title: "Business Dashboards",
    domain: "For any business",
    description: "Custom dashboards for companies that need to manage clients, sales, appointments, payments, credits, reports, AI usage and daily operations from one place.",
    link: "#",
  },
];

export default function PortfolioSection() {
  return (
    <>
      <section id="work" className="selected-work">
        <div className="container">
          <div className="section-head work-head">
            <div>
              <span className="section-kicker">Selected Work</span>
              <h2>Web projects, concepts and proprietary AI products.</h2>
            </div>
            <p>A curated selection of web projects, concept work and SaaS products built by FIKAMI.</p>
          </div>

          <div className="work-group">
            <div className="work-group-head">
              <div>
                <span className="mini-label">Web Projects & Concepts</span>
                <h3>Visual work created for brands, local businesses and product ideas.</h3>
              </div>
              <p>Portfolio visuals only. These projects are shown as design and implementation examples.</p>
            </div>

            <div className="work-grid web-projects">
              {webProjects.map((item) => (
                <article className="work-card" key={item.title}>
                  <div className="work-image">
                    <img src={item.image} alt={item.alt} loading="lazy" width="1200" height="750" />
                  </div>
                  <div className="work-body">
                    <span className="badge">{item.badge}</span>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="work-group products-group">
            <div className="work-group-head">
              <div>
                <span className="mini-label">FIKAMI Products</span>
                <h3>Proprietary SaaS products, AI-driven tools and operational dashboards.</h3>
              </div>
              <p>Active products and internal systems developed by FIKAMI, including SaaS tools, AI products and dashboard-based control platforms.</p>
            </div>

            <div className="work-grid products-grid">
              {products.map((item) => (
                <article className="work-card product-card" key={item.title}>
                  <div className="work-image">
                    <img src={item.image} alt={item.alt} loading="lazy" width="1200" height="750" />
                  </div>
                  <div className="work-body">
                    <span className="badge product-badge">{item.badge}</span>
                    <h4>{item.title}</h4>
                    <a className="product-domain" href={item.link} target="_blank" rel="noopener noreferrer">
                      {item.domain}
                    </a>
                    <p>{item.description}</p>
                    <a className="work-link" href={item.link} target="_blank" rel="noopener noreferrer">
                      Visit product
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .selected-work {
          padding: 110px 0;
          background: radial-gradient(circle at 15% 10%, rgba(255, 90, 0, 0.12), transparent 30%), radial-gradient(circle at 85% 15%, rgba(255, 255, 255, 0.08), transparent 26%), #080808;
          color: #f7f7f7;
        }
        .selected-work .work-head {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          gap: 32px;
          margin-bottom: 56px;
        }
        .selected-work .section-kicker,
        .selected-work .mini-label {
          display: inline-block;
          margin-bottom: 14px;
          color: #ff5a00;
          font-size: 0.78rem;
          font-weight: 800;
          letter-spacing: 0.18em;
          text-transform: uppercase;
        }
        .selected-work h2 {
          max-width: 780px;
          font-size: clamp(2.4rem, 5vw, 4.8rem);
          line-height: 0.95;
          letter-spacing: -0.06em;
          margin: 0;
        }
        .selected-work .work-head p {
          max-width: 420px;
          color: rgba(255, 255, 255, 0.62);
          line-height: 1.7;
          margin: 0;
        }
        .work-group { margin-top: 54px; }
        .work-group-head {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          gap: 24px;
          margin-bottom: 24px;
        }
        .work-group-head h3 {
          max-width: 720px;
          font-size: clamp(1.5rem, 3vw, 2.2rem);
          letter-spacing: -0.04em;
          line-height: 1.08;
          margin: 0;
        }
        .work-group-head p {
          max-width: 520px;
          color: rgba(255, 255, 255, 0.56);
          line-height: 1.6;
          margin: 0;
        }
        .work-grid { display: grid; gap: 22px; }
        .web-projects { grid-template-columns: repeat(4, minmax(0, 1fr)); }
        .products-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        .work-card {
          overflow: hidden;
          border-radius: 28px;
          background: rgba(255, 255, 255, 0.055);
          border: 1px solid rgba(255, 255, 255, 0.12);
          box-shadow: 0 26px 80px rgba(0, 0, 0, 0.28);
          transition: transform 0.22s ease, border-color 0.22s ease, background 0.22s ease;
        }
        .work-card:hover {
          transform: translateY(-6px);
          border-color: rgba(255, 90, 0, 0.42);
          background: rgba(255, 255, 255, 0.075);
        }
        .work-image {
          aspect-ratio: 16 / 10;
          overflow: hidden;
          background: #121212;
        }
        .work-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.35s ease;
        }
        .work-card:hover .work-image img { transform: scale(1.035); }
        .work-body { padding: 22px; }
        .badge {
          display: inline-flex;
          margin-bottom: 14px;
          padding: 7px 10px;
          border-radius: 999px;
          background: rgba(255, 90, 0, 0.12);
          color: #ff8a3d;
          font-size: 0.72rem;
          font-weight: 800;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }
        .product-badge {
          background: rgba(255, 255, 255, 0.12);
          color: #ffffff;
        }
        .work-body h4 {
          font-size: 1.22rem;
          letter-spacing: -0.035em;
          margin: 0 0 10px;
        }
        .product-domain {
          display: inline-flex;
          margin-bottom: 14px;
          color: #ff8a3d;
          font-size: 0.95rem;
          font-weight: 800;
          text-decoration: none;
        }
        .product-domain:hover {
          color: #ff5a00;
        }
        .work-body p {
          color: rgba(255, 255, 255, 0.62);
          line-height: 1.65;
          margin: 0;
          font-size: 0.94rem;
        }
        .work-link {
          margin-top: 20px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 44px;
          padding: 0 18px;
          border-radius: 999px;
          background: #ff5a00;
          color: #ffffff;
          font-weight: 800;
          transition: transform 0.2s ease, background 0.2s ease;
          text-decoration: none;
        }
        .work-link:hover {
          transform: translateY(-2px);
          background: #ff7430;
        }
        @media (max-width: 1100px) {
          .web-projects { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        }
        @media (max-width: 760px) {
          .selected-work { padding: 78px 0; }
          .selected-work .work-head,
          .work-group-head {
            flex-direction: column;
            align-items: flex-start;
          }
          .web-projects,
          .products-grid { grid-template-columns: 1fr; }
        }
      `}</style>
    </>
  );
}
